import { render, staticRenderFns } from "./Artworks.vue?vue&type=template&id=7722747b&scoped=true&"
import script from "./Artworks.vue?vue&type=script&lang=js&"
export * from "./Artworks.vue?vue&type=script&lang=js&"
import style0 from "./Artworks.vue?vue&type=style&index=0&id=7722747b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7722747b",
  null
  
)

export default component.exports